import React, { useEffect } from "react";
import { useAcumuladorCantidad } from "./../../Hooks/Custom.hooks";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Opciones.component.scss";

const OpcionesCOmponent = ({
  hayCliente = false,
  cerrarSession,
  productos = [],
}) => {
  const [cantidadAcumulado, setCantidad] = useAcumuladorCantidad(productos);

  useEffect(() => {
    setCantidad(productos);
  }, [productos]);

  const HeaderUsuario = () => {
    if (!hayCliente) {
      return (
        <NavLink
          className="Header__Opciones--Link"
          to="/Login"
          activeClassName="Header__Opciones--Link-Actual"
        >
          <FontAwesomeIcon icon={["fas", "sign-in-alt"]} />
          <span>Ingresar</span>
        </NavLink>
      );
    } else {
      return (
        <>
          <NavLink
            className="Header__Opciones--Link"
            to="/Historial"
            activeClassName="Header__Opciones--Link-Actual"
          >
            <FontAwesomeIcon icon={["fas", "list-alt"]} />
          </NavLink>
          <NavLink
            className="Header__Opciones--Link"
            to="/Carrito"
            activeClassName="Header__Opciones--Link-Actual"
          >
            <FontAwesomeIcon icon={["fas", "shopping-cart"]} />
            <span>{cantidadAcumulado}</span>
          </NavLink>
          <a
            className="Header__Opciones--Link"
            href="/#"
            onClick={cerrarSession}
          >
            <FontAwesomeIcon icon={["fas", "sign-out-alt"]} />
            {/* <span>Cerrar sesión</span> */}
          </a>
        </>
      );
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-lg-3 offset-lg-9">
        <div className="Header__Opciones">
          <HeaderUsuario />
        </div>
      </div>
    </div>
  );
};

export default OpcionesCOmponent;
